module.exports = __webpack_public_path__ + "static/media/logo.38c90562.png";